$(function() {
    $(".video-model").find('iframe').each(function() {
      var sourceFile = $(this).attr("dataSrc");
      $(this).attr("src", sourceFile);
    });
  });
$(document).ready(function () {
    

    // $('#videomodal').find('iframe').attr('src',$('#videomodal').find('iframe').attr('dataSrc'));
    
    $('.about-us-page .internal-cta').click(function() {
        $(".about-us-page #videomodal").modal("show");
    });
    $("#videomodal").on('hidden.bs.modal', function (e) {
        $("#videomodal iframe").attr("src", $("#videomodal iframe").attr("src"));
    });
    function hasWebP() {
        var rv = $.Deferred(), img = new Image();
        img.onload = function () { rv.resolve(); };
        img.onerror = function () { rv.reject(); };
        img.src = "https://mobisoftinfotech.com/assets/images/products/rideshare-dev/webp/intro-solution.webp";
        return rv.promise();
    }

    hasWebP().then(function () {
        $("html").removeClass('no-setclasses');
    }, function () {
        $("html").addClass('no-setclasses');
    });


    var testimonialSwiper = function () {
        $(".swiper-slide").click(function(){
            swiper.params.autoplay = {
                delay:10000
            };
        });
        var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            loop: true,
            speed:2000,
            direction: 'horizontal',
            autoplay: 
            {
                delay:5000,
            },
            // autoplay: 5000,
            effect:'slide',
            grabCursor: true,
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },

        });
        setInterval(function () {
            $(' .swiper-container').css({ height : "100%" });
            var newHeight = $(".swiper-slide-active").height();
            $(' .swiper-container').css({ height : 1.1*newHeight });
         }, 500);

    }

    // testimonialSwiper();
    //event slider
    $(document).ready(function() {
        // Swiper: Slider
            new Swiper('.swiper-container', {
                loop: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                pagination: {
                    el: '.swiper-pagination',
                },
                slidesPerView: 3,
                paginationClickable: true,
                spaceBetween: 20,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    1920: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1028: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    }
                }
            });
        });
//event slider end
    var ink, d, x, y;
    $(".ripplelink").click(function (e) {

        if ($(this).find(".ink").length === 0) {
            $(this).prepend("<span class='ink'></span>");
        }

        ink = $(this).find(".ink");
        ink.removeClass("animate");

        if (!ink.height() && !ink.width()) {
            d = Math.max($(this).outerWidth(), $(this).outerHeight());
            ink.css({ height: d, width: d });
        }

        x = e.pageX - $(this).offset().left - ink.width() / 2;
        y = e.pageY - $(this).offset().top - ink.height() / 2;

        ink.css({ top: y + 'px', left: x + 'px' }).addClass("animate");
    });


    $('body').scrollspy({ target: ".navbar", offset: 100 });
    $("#myNavbar a").on('click', function (event) {
        var offset_top = Number( $('.tab-menu').height() + $('.navbar').height() + 70);
        $("#myNavbar a").removeClass('active');
        $(this).addClass('active');
        if($(this).parents('.tab-menu').hasClass('fixed')) {
            offset_top = 115
        }else{
            offset_top = offset_top;
        }
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
                scrollTop: $(hash).offset().top - offset_top
            });
        }
    });


    $(".banner-btn a").on('click', function (event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 80
            });
        }
    });


    $(".go-to-footer-form").click(function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: $(".sec-contact").offset().top
        },
            800, function () {
                $('#name').focus();
            });
    });

    $(".taxi-btn, .enquire-btn").hover(function () {
        $(this).find("span").toggleClass("jump");
    });

    $(".dis-wrap").hover(function () {
        $(this).find(".taxi-sprite").toggleClass(" fadeInUp");
    });

    $('#back-top').click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    })

    /*=====Count animation===========*/
    if ($('body').hasClass('about-us-page solution-page')) {
        var a = 0,
            expOffset = $('.about-us').offset().top - 400;
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (a == 0 && scroll >= expOffset) {
                $('.mscount').each(function () {
                    var mm = $(this).attr('data-start');
                    $(this).attr('data-start', mm).animate({
                        Counter: $(this).text()
                    }, {
                            duration: 4000,
                            easing: 'swing',
                            step: function (now) {
                                $(this).text(Math.ceil(now));
                            }
                        });
                });
                a = 1;
            }
        });
    }

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        var headerStick = $('#headNavBar');
        if (scroll > headerStick.height()) {
            headerStick.addClass('fixed');
            $('#back-top').show();
        }
        else {
            headerStick.removeClass('fixed');
            $('#back-top').hide();
        }
        if ($('body').hasClass('overview-page')) {
            headerStick.removeClass('fixed');
            var sticky1 = $('#myNavbar .tab-menu'),
                partner_top = $('.footer').offset().top;

            if (scroll <= partner_top && scroll > 100) sticky1.addClass('fixed');
            else sticky1.removeClass('fixed');
        }
    });


    $('.dropdown, .dropdown-content').on({
        mouseenter: function (e) {
            e.preventDefault();
            $('#mclose').css({
                visibility: 'visible',
                opacity: 0.6
            });
        },
        mouseleave: function () {
            $('#mclose').css({
                visibility: 'hidden',
                opacity: 0
            });
        }
    });
    
});

